import React, { useState } from 'react'
import styled from 'styled-components'

import Container from 'components/Container'
import Tooltip from 'components/Tooltip'

const PageHeader = ({
  icon,
  subtitle,
  title,
  onClick,
  isShare,
  tooltip,
  edit,
  editable,
  token,
}) => {
  const hashLink = `${process.env.REACT_APP_VIEW_TRANSCATION_URL}/address/${token}`

  return (
    <Container size="md">
      <StyledPageHeader onClick={onClick}>
        <StyledIcon>{icon}</StyledIcon>
        <StyledTitle>
          {title}
          {tooltip ? <Tooltip text={tooltip} isShare={isShare} /> : <></>}
        </StyledTitle>
        {token && (
          <StyledText>
            Token Contact :&nbsp;
            <StyledExternalLink href={hashLink} target="_blank">
              {token}
            </StyledExternalLink>
          </StyledText>
        )}
        <StyledEditIcon>{editable && edit}</StyledEditIcon>
        <StyledSubtitle>{subtitle}</StyledSubtitle>
      </StyledPageHeader>
    </Container>
  )
}

const StyledPageHeader = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding-bottom: ${(props) => props.theme.spacing[6]}px;
  padding-top: ${(props) => props.theme.spacing[6]}px;
  margin: 0 auto;
`

const StyledIcon = styled.div`
  font-size: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  width: 120px;
`

const StyledTitle = styled.h1`
  font-family: 'Kaushan Script', sans-serif;
  color: ${(props) => props.theme.color.grey[600]};
  font-size: 36px;
  font-weight: 700;
  margin: 0;
  padding: 0;
`

const StyledSubtitle = styled.div`
  color: ${(props) => props.theme.color.grey[400]};
  font-size: 18px;
  font-weight: 400;
  margin: 0;
  text-align: left;
  display: block;
`

const StyledEditIcon = styled.div`
  margin: 0;
  display: flex;
  position: relative;
  left: 50%;
  top: 50px;
  opacity: 0.8;
  cursor: pointer;
`
const StyledExternalLink = styled.a`
  align-items: center;
  display: flex;
  color: inherit;
  flex: 1;
  justify-content: center;
  padding: 10 ${(props) => props.theme.spacing[4]}px;
`

const StyledText = styled.h4`
  align-items: center;
  display: flex;
  color: inherit;
  flex: 1;
  justify-content: center;
  margin: 10px ${(props) => -props.theme.spacing[4]}px;
  padding: 10 ${(props) => props.theme.spacing[4]}px;
`
export default PageHeader
